export const iconFontAwesomeCampingTrailer = (
	<i className="fa-solid fa-trailer"></i>
);
